var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.token),expression:"token"}],attrs:{"type":"hidden","name":"csrfmiddlewaretoken"},domProps:{"value":(_vm.token)},on:{"input":function($event){if($event.target.composing)return;_vm.token=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }